import type { TaskStatus } from '@serb/shared';
import type { Tone } from '../../components/tone';

export const TASK_LABEL: Record<TaskStatus, string> = {
  waiting: 'Waiting',
  working: 'Working',
  needs_you: 'Needs you',
  done: 'Done',
  failed: 'Failed',
};

export const TASK_TONE: Record<TaskStatus, Tone> = {
  waiting: 'info',
  working: 'warning',
  needs_you: 'error',
  done: 'success',
  failed: 'error',
};
